import http from '../http-common';

const apiOrigin = () => (http.defaults.baseURL || '').replace(/\/api$/, '');

/** Turn `/files/...` from the API into an absolute URL for <img> and CSS url(). */
export const resolveUploadedFileUrl = (fileUrl) => {
  if (!fileUrl) return null;
  if (fileUrl.startsWith('data:') || fileUrl.startsWith('http')) return fileUrl;
  const base = apiOrigin();
  const pathPart = fileUrl.startsWith('/') ? fileUrl : `/${fileUrl}`;
  return `${base}${pathPart}`;
};

const getBackground = () => http.get('/info-screen/background');

const uploadBackground = (formData) => http.post('/info-screen/background', formData);

const getNotice = () => http.get('/info-screen/notice');

const updateNotice = (text) => http.put('/info-screen/notice', { text });

export const InfoScreenService = {
  getBackground,
  uploadBackground,
  getNotice,
  updateNotice,
  resolveUploadedFileUrl,
};
